import $ from 'jquery';
import _ from './helpers';
import scrollTo from 'jquery.scrollto';

// Add and remove dark navigation styles
function toggleDarkNav() {
  const hero = document.querySelector('.hero');
  const header = document.querySelector('.site-header');
  const heroBottom = hero.offsetHeight - header.offsetHeight;
  const windowY = window.pageYOffset;
  const hasDarkClass = header.classList.contains('dark-header');

  if (windowY > heroBottom && !hasDarkClass) {
    header.classList.add('dark-header');
  }

  if (windowY < heroBottom && hasDarkClass) {
    header.classList.remove('dark-header');
  }
}

window.addEventListener('scroll', _.throttle(toggleDarkNav, 100));

// Info carousel
$('.carousel__icons > li').click(switchSlide);

function switchSlide(e) {
  const id = $(this).attr('class');
  const hoverImg = $(this).data('img').hoverImg;

  if(!$(this).hasClass('active')) {
    // set active icon.
    $(this).children(':first').attr('src', hoverImg);

    $.each($('.carousel__icons > li'), (i, item) => {
      const defaultImg = $(item).data('img').defaultImg;

      if($(item).hasClass('active')) {
        $(item).children(':first').attr('src', defaultImg);
      }
    });

    // swap active slide.
    $('.carousel__slide').removeClass('active');
    $((`div.${id}`)).addClass('active');

    $('.carousel__icons > li').removeClass('active');
    $(this).addClass('active');

    $(".slick-slider").slick("refresh");
  }
}

// Dollhouse rendering
// Set Dollhouse button size relative to map image
window.onload = setButtonSize;
$(window).resize(setButtonSize);

function setButtonSize() {
  const buttons = $('.dollhouse__button');
  const map = $('.dollhouse__map');

  buttons.width( map.width() * .1445 );
}

// swap images on hover
$('.dollhouse__button').hover(swapHoverImage);
$('.carousel__icons > li').hover(swapHoverImage);

function swapHoverImage(e) {
  const defaultImg = $(this).data('img').defaultImg;
  const hoverImg = $(this).data('img').hoverImg;

  if(hoverImg && !$(this).hasClass('active')) {
    if(e.type == 'mouseenter') {
      $(this).children(':first').attr('src', hoverImg);
    }

    if(e.type == 'mouseleave') {
      $(this).children(':first').attr('src', defaultImg);
    }
  }
}

// Add flexbox only to slides that have a caption
$('.renovations .slide__caption').parent('.slide__inner').addClass('flex-slide');

// Scrolling navigation
$('.main-navigation a').click(scrollDown);

function scrollDown(e, offset) {
  const sectionClass = `.${$(this).attr('href').split('#')[1]}`;
  const menuSize = $('.site-header').outerHeight();

  e.preventDefault();

  $(window).scrollTo(sectionClass, {
    duration: 300,
    offset: {
      top: -menuSize
    }
  });
}



// WEBPACK FOOTER //
// js/src/global/index.js